import Timer from "components/atoms/Timer";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";

type Props = {
  nextAt: string;
  isDisabled: boolean;
  onClick: () => void;
};

export const WheelAction = ({
  nextAt,
  isDisabled,
  onClick: handleSpin,
}: Props) => {
  const t = useTranslate();

  return (
    <div className="WheelAction">
      <div className="WheelAction__text">
        {nextAt
          ? t("wheel.fortune.not.available")
          : t("wheel.fortune.available.spin")}
      </div>
      {nextAt ? (
        <div className="WheelAction__timer">
          <Timer finishDate={nextAt} isWheel />
        </div>
      ) : (
        <button
          type="button"
          className="WheelAction__btn"
          onClick={handleSpin}
          disabled={isDisabled}
          aria-busy={isDisabled}
        >
          {t("wheel.fortune.button.spin")}
        </button>
      )}
    </div>
  );
};
